import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreditNotesReceivableForm.FieldsSection', {
    contactFieldTitle: 'Customer',
    contactFieldPlaceholder: 'Select customer',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Enter date',
    referenceFieldTitle: 'Reference',
    referenceFieldPlaceholder: 'Enter reference',
    numberFieldTitle: 'Order number',
    numberFieldPlaceholder: 'Enter order number',
    addContactButton: '+ New Contact',
    themeFieldTitle: 'Theme',
    themeFieldPlaceholder: 'Choose theme',
});
